import { ref } from 'vue';
import { LoadingModalController } from "@/components/Modal/Generic/LoadingModal/LoadingModalController"
/**
 *
 * @param {*} modalStore
 * @returns {import("@/types/Modal.d").LoadingModalComposition}
 */
export default function useLoadingModal (modalStore) {
    const isLoading = ref(false);
    const modalController = modalStore.methods.getModalController();
    if (modalController.loadingModal == null) {
        modalController.setLoadingModal(new LoadingModalController())
    }

    const loadingModal = modalController.loadingModal;

    const toggleLoading = function () {
        if (isLoading.value) {
            showLoadingModal();
        } else {
            hideLoadingModal();
        }

        return isLoading.value;
    };

    const showLoadingModal = function () {
        if (isLoading.value) return true;

        loadingModal.show();

        isLoading.value = true;
        return false;
    };

    const hideLoadingModal = function () {
        loadingModal.hide();

        isLoading.value = false;
    };

    return {
        loadingModal,
        isLoading,
        toggleLoading,
        showLoadingModal,
        hideLoadingModal,
    };
}
